import { createAsyncThunk } from '@reduxjs/toolkit'
import { getAllOperatorReportService, getAllPeriodicReportService, getTopProfitReportsService } from 'network/services/reports/operatorReports.service'

export const fetchAllOperatorsReport = createAsyncThunk(
  'fetch/allOperatorReport',
  async ({ params }, thunkApi) => {
    try {
      const res = await getAllOperatorReportService(params)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchTopProfitReports = createAsyncThunk(
  'fetch/topProfitReport',
  async ({ params }, thunkApi) => {
    try {
      const res = await getTopProfitReportsService(params)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchAllPeriodicReport = createAsyncThunk(
  'fetch/allPeriodicReport',
  async ({ params }, thunkApi) => {
    try {
      const res = await getAllPeriodicReportService(params)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)
